import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

/**
 * Puts the host in the browser's top layer, above everything that is not itself in the top layer, whatever its z-index.
 * Since CDK 21 every overlay (dialogs, menus, snackbars) is a popover in the top layer, so a plain fixed element
 * with a huge z-index ends up behind a dialog. Elements shown later sit above those shown earlier.
 */
@Directive({
  selector: '[appTopLayer]',
  standalone: true,
  host: { popover: 'manual' }
})
export class TopLayerDirective implements AfterViewInit {
  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  ngAfterViewInit(): void {
    const el = this.el.nativeElement;
    if (typeof el.showPopover === 'function' && el.isConnected) {
      el.showPopover();
    }
  }
}
